import { IKeyValue, KeyValueEntity } from './BasicEntities';
import { observable } from 'mobx';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

export interface IProductShadeGroup extends IKeyValue {
    src: string;
    alt: string;
    assetType?: string;
}

export class ProductShadeGroup extends KeyValueEntity {
    @observable public position: number = 0;

    public static fromJson(shadeGroup: IProductShadeGroup): ProductShadeGroup {
        const newShadeGroup = new ProductShadeGroup();
        if (shadeGroup) {
            copyPropertiesExcludeNullsAndGetters(newShadeGroup, shadeGroup);
        }

        return newShadeGroup;
    }
}
